import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationAutomation } from './async.tsx';

export const IntegrationAutomation = () => (
	<LazyPage
		Page={LazyIntegrationAutomation}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
